var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"사무소 정보"}},[_c('plan-project-info')],1),_c('vs-tab',{attrs:{"label":"조직도"}},[_c('plan-project-organization')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }